module.exports = __webpack_public_path__ + "img/workout10.0b37da26.jpg";